var map = {
	"./arrow_icon.png": 1462,
	"./first.png": 7097,
	"./left.png": 9576,
	"./logo.png": 6870,
	"./next.png": 960,
	"./next2.png": 1792,
	"./nextcurrent.png": 881,
	"./nextpage2.png": 7547,
	"./page3.png": 27,
	"./page4.png": 4388,
	"./people_after.png": 97,
	"./people_before.png": 5294,
	"./play.png": 7629,
	"./play_main.png": 209,
	"./play_white.png": 2627,
	"./playbtn.png": 1753,
	"./prev.png": 8084,
	"./prev2.png": 9564,
	"./right.png": 3517,
	"./xi_image.png": 6488,
	"./xi_text.png": 1274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9415;